import React from 'react';

const Error = () => {
    return (
        <>
            <p>Error: Page does not exist!</p>
        </>
    );
}

export default Error;